<template>
  <kendo-window ref="kendoWindowRef" :title="'운송장 번호 업로드'" :modal="true" :width="'500px'" style="display:none;">
    <template>
      <div class="pop-container">
        <div id="filter_section" class="filter_wrap w100">
          <ul class="filter_list">
            <li>
              <dd>
                <label class="w30">사업장</label>
                <ul class="w60">
                  <li>
                    <kendo-dropdownlist
                        ref="facilityRef"
                        :data-source="zone1DepthList"
                        :data-text-field="'cdNm'"
                        :data-value-field="'cdId'"
                        :option-label="'전체'"
                        :no-data-template="'표시할 데이터가 없습니다.'"
                        class="w100"
                    >
                    </kendo-dropdownlist>
                  </li>
                </ul>
              </dd>
            </li>
          </ul>
        </div>
        <div class="pop-conts">
          <div>
            <p style="color:#fe5f40;font-weight:400" class="mgt10 fl">* 엑셀 파일을 선택해주세요.</p>
          </div>
          <div class="messagepop_form_wrap">
            <div class="mp_form">
              <dd>
                <kendo-upload
                    ref="upload"
                    name="files"
                    @remove=""
                    :select="onSelectFile"
                    :multiple="false"
                    :files="file"
                    :show-file-list="true"
                    :async-auto-upload="false"
                    :validation-allowed-extensions='[".xlsx", ".xls"]'
                    style="'width: 300px;'">
                </kendo-upload>
              </dd>
            </div>
            <div>
              <p style="color:#fe5f40;font-weight:400;text-align: justify;" class="mgt10 fl">
                1. 운송장 번호를 업로드 하는 창입니다.<br>
                2. 파일에 오류가 있을 경우 내용이 등록되지 않습니다.<br>
                3. 오류 항목이 발견된 경우 파일을 수정 후 재 등록해 주세요.<br>
                4. 엑셀 파일의 확장자는 .xlsx와 .xls만 가능합니다.<br>
                5. 중복된 운송장 번호를 업로드 할 경우 등록되지 않습니다.<br>
              </p>
            </div>
          </div>
          <div class="k-text-center mgt30">
            <button type="button" id="buttonUpload" class="mid_btn orange" @click="onClickUpload">업로드</button>
          </div>
        </div>
      </div>
    </template>
  </kendo-window>
</template>

<script>
import $ from 'jquery';
import * as XLSX from "xlsx"
import {ZoneMixin} from "@/mixin/Mixin";
import app from '@/main';

export default {
  name: "BlNoExcelUploadWindow",
  mixins: [ZoneMixin],
  methods: {
    onSelectFile (e) {
      const vm = this
      const fileInfo = e.files[0]
      app.$Progress.plus()

      setTimeout(function() {
        const raw = fileInfo.rawFile
        const reader = new FileReader()
        const fileList = e.sender._module.element.find('ul')
        reader.onloadend = function(e) {
          let data = e.target.result
          let workbook = XLSX.read(data, {
            type: 'binary'
          })
          let successBool = true
        }
        reader.readAsBinaryString(raw)
        app.$Progress.minus()
      })
    },

    onClickUpload () {
      const vm = this

      // 필수값 체크
      if(!!vm.$refs.facilityRef) {
        const facility = vm.$refs.facilityRef.kendoWidget().value()
        if(!!!facility) {
          kendo.alert('사업장을 선택해주세요.')
          return false
        }
      }
    }
  },
  data () {
    return {
      loginUserToken: sessionStorage.getItem('loginUserToken'),
      file: [],

    }
  }
}
</script>

<style scoped>

</style>
